<script setup lang="ts">
import { PRichSwitch, PRichSwitchTitle, PSidePanel, PSidePanelContent, PSidePanelTrigger } from '@pokerly/ui';
import { useSessionPanelsStore } from '@/stores/session-panels.ts';
import SessionParticipantsOthers from '@/views/app/session/_components/toolbar/participants/SessionParticipantsOthers.vue';
import { computed } from 'vue';
import { useSessionStore } from '@/stores/session.ts';
import { useAuthStore } from '@/stores/auth.ts';

const sessionPanelsStore = useSessionPanelsStore();
const auth = useAuthStore();
const sessionStore = useSessionStore();

const userParticipant = computed(() => {
    const participant = sessionStore.participants.find((p) => p.id === auth.user?.id);
    const type = participant?.role === 'voter' ? 'Voter |' : 'Observer';
    const state = participant?.vote ? 'Voted' : 'Pending';
    return {
        name: auth.user?.name,
        status: `${type} ${participant?.role === 'voter' ? state : ''}`,
        isObserver: participant?.role === 'observer',
    };
});

function toggleRole() {
    if (userParticipant.value.isObserver) {
        sessionStore.setUserType('voter');
    } else {
        sessionStore.setUserType('observer');
    }
}
</script>

<template>
    <PSidePanel v-model="sessionPanelsStore.usersPanel" overlay width="240px">
        <PSidePanelContent>
            <div class="h-13 bg-white px-2 py-1 flex items-center">
                <span class="font-bold paragraph-sm px-2 py-2.5 text-foreground-primary"
                    >{{ sessionStore.participants.length }} Participant{{
                        sessionStore.participants.length === 1 ? '' : 's'
                    }}
                </span>
            </div>
            <div class="flex flex-col">
                <div class="p-2">
                    <PRichSwitch :model-value="userParticipant.isObserver" @update:model-value="toggleRole" flip>
                        <PRichSwitchTitle>Make me observer</PRichSwitchTitle>
                    </PRichSwitch>
                </div>
                <SessionParticipantsOthers />
            </div>
            <PSidePanelTrigger
                class="absolute translate-x-full -right-2"
                v-if="sessionPanelsStore.usersPanel"
                :is-open="sessionPanelsStore.usersPanel"
                @click="sessionPanelsStore.toggleUsersPanel"
            />
        </PSidePanelContent>
    </PSidePanel>
</template>
